// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__9F7aE","content":"styles_content__kooKn"};